// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"4cd1a8c8","586":"4cd1a8c8","798":"4cd1a8c8"}[chunkId] + ".chunk.css";
};